/// <reference types="jquery" />
/// <reference types="ua-parser-js" />

class HicomPage implements IHicomPage {
    Name: string;
    Controller: string;
    Action: string;
    Area: string;
    BaseUrl: string;
    Key: string;
    LoadedDateTime: Date;
    SessionTimerConfig: SessionTimerConfig;
    PageState: PageState;

    constructor(name, controller, action, baseUrl, key, area) {
        this.Name = name;
        this.Controller = controller;
        this.Action = action;
        this.Area = area;
        this.BaseUrl = baseUrl;
        this.Key = key;
        this.LoadedDateTime = new Date();
        this.PageState = new PageState(this);
        this._init();
    }

    /** 
     * Initialisation of the HicomPage 
     */
    _init() {
        let page = this;

        // @ts-ignore
        hQueryReady(() => {
            console.debug(`Page initialised: ${page.Name}`);
            console.debug(`Page Key: ${page.Key}`);
            page._setUA();
            page._setTimeZone();
        })

        // Global Ajax error handler (only fires if global not set)
        $(document).ajaxError(function (event, jqxhr, settings, thrownError) {

            if (jqxhr.status === 409) { // Concurrency issue detected
            } else if (jqxhr.status === 500) { // Concurrency issue detected
                // Checking if the page is reloaded before the ajax calls were completed.
                if (jqxhr.getAllResponseHeaders() != '') {
                    // Redirect to the error page
                    let exceptionId;
                    try {
                        // @ts-ignore
                        exceptionId = jqxhr.responseJSON.exceptionId;
                    } catch (e) { }

                    if (exceptionId) {
                        // Pass the exceptionId to the primary error page
                        window.location.href = page.BaseUrl + "/Error?exceptionId=" + exceptionId;
                    }
                    else {
                        // Fallback error page
                        window.location.href = page.BaseUrl + "/Error/HttpStatusCodeError/500";
                    }
                }
            }
        });
    }

    /**
    * Set Parsed User Agent cookie
    */
    _setUA() {
        let uaResult = new UAParser().getResult();
        let device = typeof uaResult.device.vendor === 'undefined' ? '' : uaResult.device.vendor +
            typeof uaResult.device.model === 'undefined' ? '' : uaResult.device.model +
                typeof uaResult.device.type === 'undefined' ? '' : uaResult.device.type;
        device = device === '' ? 'Other' : device;
        let ua = `Browser: ${uaResult.browser.name} ${uaResult.browser.version} | OS: ${uaResult.os.name} ${uaResult.os.version} | Device: ${device}`;
        document.cookie = encodeURI(`ParsedUA=${ua};secure;path=/;samesite=Strict`);
    }

    /**
     * Attach the time zone of the browser to a cookie
     */
    _setTimeZone() {
        // Get browser's timezone
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        // Set the cookie with the browser timezone
        document.cookie = `BrowserTimeZone=${encodeURIComponent(timezone)}; path=/; SameSite=Strict`;
    }

    startSessionTimer() {
        let showSessionExpiryWarningFrom = new Date(this.LoadedDateTime.getTime() + ((this.SessionTimerConfig.sessionLengthMinutes - this.SessionTimerConfig.minutesBeforeSessionTimeoutToShowWarning) * 60000));
        console.debug(`HicomPage::startSessionTimer - Session started - warning set to ${showSessionExpiryWarningFrom} millseconds before session expiry`);
        if (this.SessionTimerConfig.callback) {
            // Every 30 seconds, check whether we're past the time to execute the session expiry callback.
            this.SessionTimerConfig.interval = setInterval(fn => {
                if (showSessionExpiryWarningFrom < new Date()) {
                    // Yes - execute the callback function and stop the timer
                    this.SessionTimerConfig.callback();
                    clearInterval(this.SessionTimerConfig.interval);

                    // Now start another timer (running every 10 seconds) to call the logoff callback function when we reach the end of the session
                    if (this.SessionTimerConfig.logOffCallback) {
                        let sessionEndDateTime = new Date(this.LoadedDateTime.getTime() + (this.SessionTimerConfig.sessionLengthMinutes * 60000));
                        this.SessionTimerConfig.interval = setInterval(fn => {
                            if (sessionEndDateTime < new Date()) {
                                // Yes - execute the callback function and stop the timer
                                this.SessionTimerConfig.logOffCallback();
                                clearInterval(this.SessionTimerConfig.interval);
                            }
                        }, 10000);
                    }
                }
            }, 30000);
        }
    }

    resetSessionTimer() {
        this.fetchGet(`${this.BaseUrl}/WebApi/RenewSession`).then(() => {
            console.debug('HicomPage::resetSessionTimer - Session reset');
            clearInterval(this.SessionTimerConfig.interval);
            this.LoadedDateTime = new Date();
            this.startSessionTimer();
        });
    }

    /**
     * 
     * @param fn - function to execute once the DOM is ready
     */
    ready(fn) {
        // @ts-ignore
        hQueryReady(fn);
    }

    /**
     * 
     * @param fn - function to execute once the DOM & KendoSync is ready
     */
    kendoReady(fn) {
        // @ts-ignore
        hQueryReady(() => {
            // @ts-ignore
            kendo.syncReady(fn);
        })
    }

    //#region fetch helpers
    /**
     * POST non-JSON data to a url using the fetch api - IT'S VITAL YOU DON'T SET THE CONTENT-TYPE IF NOT SENDING A JSON PAYLOAD
     * @param url - url to send the data to
     * @param data - JS object to send
     * @param requestVerificationToken - XCRF token
     * 
     * @returns {Object} - JSON response parsed into a JS Object
     */
    async fetchPost(url = '', data = null, requestVerificationToken = null, parseResultAsJSON = true, bearerAuthorizationToken = null) {

        const headers = new Headers();

        // Set the headers, we always send HE-Page
        headers.append('HE-Page', 'true');

        if (requestVerificationToken != null) {
            // A request verification token has been provided, add it to the headers
            headers.append('RequestVerificationToken', requestVerificationToken);
        }

        if (bearerAuthorizationToken != null) {
            // An authorization bearer token has been provided, add it to the headers
            headers.append('Authorization', `Bearer ${bearerAuthorizationToken}`);
        }

        // Default options are marked with *
        const response = await fetch(url, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: headers, // headers array
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: data
        });

        if (!response.ok && response.status === 500) {
            const message = await response.text();
            let exceptionId;
            try {
                // @ts-ignore
                exceptionId = JSON.parse(message).exceptionId;
            } catch (e) { }

            if (exceptionId) {
                // Pass the exceptionId to the primary error page
                window.location.href = this.BaseUrl + "/Error?exceptionId=" + exceptionId;
            }
            else {
                // Fallback error page
                window.location.href = this.BaseUrl + "/Error/HttpStatusCodeError/500";
            }

            throw new Error(message);
        }

        const result = await response.text();

        if (result === null || result === undefined || result === '') {
            return null;
        }

        if (!parseResultAsJSON) {
            return result;
        }

        return JSON.parse(result); // parses JSON response into native JavaScript objects
    }

    /**
     * POST JSON data to a url using the fetch api
     * @param url - url to send the data to
     * @param data - JS object to send
     * @param requestVerificationToken - XCRF token
     * 
     * @returns {FetchResponse} - JS object wrapper, with StatusCode, Success, and Data properties - Data is the JSON response parsed into a JS Object.
     */
    async fetchPostJson(url = '', data = {}, requestVerificationToken = null, bearerAuthorizationToken = null): Promise<FetchResponse> {

        const headers = new Headers();

        // Set the headers, we always send HE-Page
        headers.append('HE-Page', 'true');
        headers.append('Content-Type', 'application/json');

        if (requestVerificationToken != null) {
            // A request verification token has been provided, add it to the headers
            headers.append('RequestVerificationToken', requestVerificationToken);
        }

        if (bearerAuthorizationToken != null) {
            // An authorization bearer token has been provided, add it to the headers
            headers.append('Authorization', `Bearer ${bearerAuthorizationToken}`);
        }

        // Default options are marked with *
        const response = await fetch(url, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: headers, // headers array
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
            body: JSON.stringify(data) // body data type must match "Content-Type" header
        });

        if (!response.ok && response.status === 500) {
            const message = await response.text();
            let exceptionId;
            try {
                // @ts-ignore
                exceptionId = JSON.parse(message).exceptionId;
            } catch (e) { }

            if (exceptionId) {
                // Pass the exceptionId to the primary error page
                window.location.href = this.BaseUrl + "/Error?exceptionId=" + exceptionId;
            }
            else {
                // Fallback error page
                window.location.href = this.BaseUrl + "/Error/HttpStatusCodeError/500";
            }

            throw new Error(message);
        }

        let wrappedResponse: FetchResponse = new FetchResponse();
        wrappedResponse.StatusCode = response.status;
        wrappedResponse.Success = response.ok;

        const result = await response.text();

        if (result === null || result === undefined || result === '') {
            return wrappedResponse;
        }

        wrappedResponse.Data = JSON.parse(result); // parses JSON response into native JavaScript objects

        return wrappedResponse;
    }

    /**
     * GET data to a url using the fetch api
     * @param url - url to send the data to
     * @param data - JS object to send
     * 
     * @returns {String} - string response
     */
    async fetchGet(url = '', data = null, bearerAuthorizationToken = null) {
        // Default options are marked with *

        if (data) {
            url += '?' + (new URLSearchParams(data)).toString();
        }

        const headers = new Headers();

        // Set the headers, we always send HE-Page
        headers.append('HE-Page', 'true');

        if (bearerAuthorizationToken != null) {
            // An authorization bearer token has been provided, add it to the headers
            headers.append('Authorization', `Bearer ${bearerAuthorizationToken}`);
        }

        const response = await fetch(url, {
            method: 'GET', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: headers, // headers array
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        });

        if (!response.ok && response.status === 500) {
            const message = await response.text();
            let exceptionId;
            try {
                // @ts-ignore
                exceptionId = JSON.parse(message).exceptionId;
            } catch (e) { }

            if (exceptionId) {
                // Pass the exceptionId to the primary error page
                window.location.href = this.BaseUrl + "/Error?exceptionId=" + exceptionId;
            }
            else {
                // Fallback error page
                window.location.href = this.BaseUrl + "/Error/HttpStatusCodeError/500";
            }

            throw new Error(message);
        }

        return response.text();
    }

    /**
     * GET the response object from a url using the fetch api
     * @param url - url to send the data to
     * @param data - JS object to send
     * 
     * @returns response object
     */
    async fetchGetReturnsResponse(url = '', data = {}) {
        // Default options are marked with *
        url += '?' + (new URLSearchParams(data)).toString();

        const response = await fetch(url, {
            method: 'GET', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
                'HE-Page': 'true'
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        });

        return response;
    }

    /**
     * GET data to a url using the fetch api
     * @param url - url to send the data to
     * @param data - JS object to send
     * 
     * @returns {Object} - JSON response parsed into a JS Object
     */
    async fetchGetJson(url = '', data = null, bearerAuthorizationToken = null) {
        // Default options are marked with *

        if (data) {
            url += '?' + (new URLSearchParams(data)).toString();
        }

        const headers = new Headers();

        // Set the headers, we always send HE-Page
        headers.append('HE-Page', 'true');

        if (bearerAuthorizationToken != null) {
            // An authorization bearer token has been provided, add it to the headers
            headers.append('Authorization', `Bearer ${bearerAuthorizationToken}`);
        }

        const response = await fetch(url, {
            method: 'GET', // *GET, POST, PUT, DELETE, etc.
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: headers, // headers array
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        });

        if (!response.ok && response.status === 500) {
            const message = await response.json();
            let exceptionId;
            try {
                // @ts-ignore
                exceptionId = message.exceptionId;
            } catch (e) { }

            if (exceptionId) {
                // Pass the exceptionId to the primary error page
                window.location.href = this.BaseUrl + "/Error?exceptionId=" + exceptionId;
            }
            else {
                // Fallback error page
                window.location.href = this.BaseUrl + "/Error/HttpStatusCodeError/500";
            }

            throw new Error(message);
        }

        return response.json();
    }

    async loadHtml(url: string, selector: string) {
        await this.fetchGet(url)
            .then((response) => {
                document.querySelector(selector).setAttribute('data-url-loaded', 'true');
                $(selector).html(response);
            });
    };

    //#endregion

    async UpdateRowVersion(id: string, rowVersionElementId: string): Promise<Boolean> {
        var result = await this.fetchGetJson(`${this.BaseUrlWithAreaAndController()}/GetRowVersion/${id}`);
        if (result.Success) {
            (<HTMLInputElement>document.getElementById(rowVersionElementId)).value = result.ReturnValue;
            return true;
        }

        console.error("Failed to retrieve a RowVersion from hicomPage.GetUpdatedRowVersion().");
        return false;
    }

    BaseUrlWithAreaAndController(): string {
        return `${[this.BaseUrl, this.Area, this.Controller].filter(Boolean).join("/")}`;
    }
}

/**
 * Wrapper around responses returned by HTTP Fetch calls
 */
class FetchResponse {
    StatusCode: number;
    Success: boolean;
    Data: any;
}

/**
 * Handles the persistence of state for a HicomPage
 */
class PageState {
    hicomPage: HicomPage;

    constructor(hicomPage: HicomPage) {
        this.hicomPage = hicomPage;
        this._init();
    }

    /** 
     * Initialisation of PageState
     */
    private _init() {
        this.hicomPage.ready(() => {

            // add event listeners for clearing the page state
            const clearStateList = document.querySelectorAll('.engine-clear-page-state:not(.nav-item-link.active)')
            clearStateList.forEach(el => {
                el.addEventListener('click', e => {
                    this.clearPageState();
                });
            })

            // Create instances of implemented IPageStateComponent class:

            // Tabs from hicomWidgets.ts
            if (typeof (PageStateTabs) !== 'undefined') { new PageStateTabs(this); }
            // Accordion from hicomWidgets.ts
            if (typeof (PageStateAccordion) !== 'undefined') { new PageStateAccordion(this); }
        });
    }

    //#region PageState persistance helpers

    /**
     * Persists the state for the item in the page state for the page it is on
     * @param key {string}  - unique identifier for the item
     * @param state {any}   - the state data to persist
    */
    private getPageState(): any {
        let pageState = JSON.parse(sessionStorage['page-state'] || '[]');
        let pageStateIndex = pageState.findIndex(x => x.pageKey === this.hicomPage.Key);
        if (pageStateIndex != -1) {
            return pageState[pageStateIndex];
        }
    }

    /**
     * Persists the state for the item in the page state for the page it is on
     * @param key {string}  - unique identifier for the item
     * @param state {any}   - the state data to persist
    */
    private setPageState(state) {
        let pageState = JSON.parse(sessionStorage['page-state'] || '[]');
        let pageStateIndex = pageState.findIndex(x => x.pageKey === this.hicomPage.Key);
        if (pageStateIndex != -1) { // if already exists, delete
            pageState.splice(pageStateIndex, 1);
        }
        const pageStateData = {
            pageKey: this.hicomPage.Key,
            items: state.items
        };
        pageState.push(pageStateData);
        sessionStorage['page-state'] = JSON.stringify(pageState);
    }

    /**
     * Persists the state for the item in the page state for the page it is on
     * @param key {string}  - unique identifier for the item
     * @param state {any}   - the state data to persist
    */
    private clearPageState() {
        // Now we just remove page-state from session storage rather than trying 
        // to delete the entry that correlates with the page we are moving away from
        sessionStorage.removeItem('page-state');
    }

    /**
     * Persists the state for the item in the page state for the page it is on
     * @param key {string}  - unique identifier for the item
     * @param state {any}   - the state data to persist
    */
    getPageStateItem(key: string) {
        let pageState = this.getPageState();
        if (!pageState) {
            return;
        }
        let index = pageState.items.findIndex(x => x.key === key);
        if (index != -1) {
            return pageState.items[index];
        }
    }

    /**
     * Persists the state for the item in the page state for the page it is on
     * @param key {string}  - unique identifier for the item
     * @param state {any}   - the state data to persist
    */
    setPageStateItem(key: string, itemState) {
        let pageState = this.getPageState();
        if (!pageState) {
            pageState = { items: [] };
            this.setPageState(pageState);
        }
        let index = pageState.items.findIndex(x => x.key === key);
        if (index != -1) { // if already exists, delete
            pageState.items.splice(index, 1);
        }
        pageState.items.push(itemState);

        this.setPageState(pageState);
    }

    //#endregion
}

class SessionTimerConfig {
    sessionLengthMinutes: number;
    minutesBeforeSessionTimeoutToShowWarning: number;
    callback: Function;
    logOffCallback: Function;
    interval: number;

    constructor(sessionLengthMinutes: number, minutesBeforeSessionTimeoutToShowWarning: number, callback: Function, logOffCallback: Function) {
        this.sessionLengthMinutes = sessionLengthMinutes;
        this.minutesBeforeSessionTimeoutToShowWarning = minutesBeforeSessionTimeoutToShowWarning;
        this.callback = callback;
        this.logOffCallback = logOffCallback;
    }
}